import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function Confidentialite() {
  const navigate = useNavigate();
  const sections = [
    { t: "1. Données que nous collectons", c: "Nous collectons les informations que tu fournis lors de l'inscription (nom, email, date de naissance) et du questionnaire (objectif, niveau, taille, poids, préférences alimentaires, informations de sécurité). Ces données servent uniquement à personnaliser ton programme de bien-être." },
    { t: "2. Consentement", c: "Le traitement de tes données de poids et de taille est réalisé avec ton consentement explicite, recueilli lors du questionnaire. Tu peux retirer ce consentement à tout moment en nous contactant." },
    { t: "3. Utilisation des données", c: "Tes données servent à générer et ajuster ton programme d'entraînement et ton plan alimentaire, à suivre ta progression et à t'envoyer des emails liés au service (bienvenue, rappel de bilan). Nous ne vendons jamais tes données." },
    { t: "4. Finalité bien-être", c: "Pousse propose un accompagnement de bien-être général. Le service ne fournit aucun diagnostic, conseil médical ou promesse de résultat, et ne remplace pas l'avis d'un professionnel de santé." },
    { t: "5. Conservation & sécurité", c: "Tes données sont conservées de manière sécurisée pendant la durée de ton abonnement. Elles sont supprimées ou anonymisées sur demande." },
    { t: "6. Tes droits", c: "Conformément au RGPD, tu disposes d'un droit d'accès, de rectification, d'effacement et de portabilité de tes données. Pour exercer ces droits, contacte-nous à l'adresse de support." },
    { t: "7. Paiements", c: "Les paiements sont traités de manière sécurisée par Stripe. Nous ne stockons jamais tes données de carte bancaire." },
  ];
  return (
    <div className="min-h-screen bg-[#0A0F0D] text-white px-5 py-8">
      <div className="max-w-md mx-auto sm:max-w-2xl">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-sm text-white/60 mb-6 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Retour
        </button>
        <div className="flex items-center gap-3 mb-6">
          <div className="h-11 w-11 rounded-2xl bg-lime-400/15 flex items-center justify-center">
            <ShieldCheck className="h-6 w-6 text-lime-400" />
          </div>
          <h1 className="font-display text-3xl font-black">Politique de confidentialité</h1>
        </div>
        <p className="text-sm text-white/50 mb-8">Dernière mise à jour : juin 2026</p>
        <div className="space-y-5">
          {sections.map((s) => (
            <div key={s.t} className="rounded-2xl border border-white/10 bg-[#141C17] p-5">
              <h2 className="font-display font-bold text-lg mb-2">{s.t}</h2>
              <p className="text-sm text-gray-300 leading-relaxed">{s.c}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-white/30 mt-8 text-center">
          Programme bien-être général, ne remplace pas l'avis d'un professionnel de santé.
        </p>
      </div>
    </div>
  );
}
